<template>
  <div
    v-html="require('!html-loader!@/assets/icon-' + this.icon + '.svg')"
  ></div>
</template>

<style module>
.svg {
  vertical-align: middle;
}
</style>

<script>
export default {
  props: {
    icon: String,
    fill: String,
    height: String,
    width: String
  },
  mounted() {
    this.$el.firstChild.classList.add(this.$style.svg);
    this.$el.lastChild.setAttribute("fill", this.fill);
    this.$el.firstChild.style.height = this.height;
    this.$el.firstChild.style.width = this.width;
  }
};
</script>
